export class BadgeListModel {
    companySurrKey: number;
    badgeList: Array<number>;
}
